import { VersionListContainer } from "./VersionList.styled";
import VersionListCards from "./VersionListCards";
import { Scrollbar } from "@ann/web-components";


const VersionList = () => {
  const versions = [
    { name: 'Jane Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'Jane Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'Jane Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'Jane Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'Jane Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
    { name: 'Jane Doe', date: new Date() },
    { name: 'John Doe', date: new Date() },
  ];

  return (
    <Scrollbar>
      <VersionListContainer>
          {versions.map((version, index) => (
            <VersionListCards key={index} name={version.name} date={version.date} />
          ))}
      </VersionListContainer>
    </Scrollbar>
  )};

export default VersionList;